export default {
    apikey: "ebcac807"
}